import React, { useState } from "react";
import get from "lodash/get";
import { Form, Button, Modal, Row, Col } from "antd";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-lua";
import "ace-builds/src-noconflict/theme-twilight";

import snippets from "./RuleLogicSnippets.json";

const RuleLogicEditor = ({ form, event, getEventFieldName }) => {
  const fieldName = "rule_logic";
  const fieldValue = get(event, fieldName, undefined);
  const [editorOpen, setEditorOpen] = useState(false);
  const fullFieldName = getEventFieldName(event, fieldName);

  return (
    <Form.Item
      label="Rule logic"
      labelCol={{ span: 3 }}
      wrapperCol={{ span: 21 }}
    >
      <Button size="small" onClick={() => setEditorOpen(true)}>
        {!fieldValue ? "Add rule logic" : "Edit rule logic"}
      </Button>
      <Modal
        visible={editorOpen}
        onCancel={() => setEditorOpen(false)}
        title="Edit the rule logic"
        footer={null}
        centered
        width="80vw"
      >
        <Row gutter={[8, 8]}>
          <Col xs={18}>
            {editorOpen &&
              form.getFieldDecorator(fullFieldName, {
                initialValue: fieldValue,
              })(
                <AceEditor
                  mode="lua"
                  theme="twilight"
                  name={fieldName}
                  width="100%"
                  tabSize={2}
                />
              )}
            <br />
            <Button
              onClick={() => {
                if (
                  window.confirm(
                    "All code in the editor will be replaced. Are you sure?"
                  )
                ) {
                  form.setFieldsValue({ [fullFieldName]: "" });
                }
              }}
            >
              Clear rule logic
            </Button>
          </Col>
          <Col xs={6}>
            {snippets.map(({ name, code }, index) => (
              <Button
                block
                size="large"
                onClick={() => {
                  if (
                    window.confirm(
                      "All code in the editor will be replaced. Are you sure?"
                    )
                  ) {
                    form.setFieldsValue({ [fullFieldName]: code });
                  }
                }}
                style={{
                  whiteSpace: "normal",
                  height: "auto",
                  padding: "10px 15px",
                }}
              >
                {name}
              </Button>
            ))}
          </Col>
        </Row>
      </Modal>
    </Form.Item>
  );
};

export default RuleLogicEditor;
